export const ROUTES = {
  ROOT: '/',
  HOME: '/home',
  /** Path pattern for the game route (use `gameRoute(brandId)` for navigation). */
  GAME: '/game/:brandId',
  NOT_FOUND: '/404',
  SANDBOX: '/sandbox/*',
  GUEST: '/guest',
  ERROR: '/error',
  FIRST_TIME_VISIT: '/first-time-visit',
  MARKETING_CONSENTS: '/marketing-consents',
  DEV_LOGIN: '/dev-login',
  COUPONS: '/coupons',
  DASHBOARD: '/dashboard',
  /** Path pattern for the brand dashboard route (use `dashboardBrandRoute(brandId)` for navigation). */
  DASHBOARD_BRAND: '/dashboard-brand/:brandId',
  NOT_AVAILABLE: '/not-available',
  LOTTERY: '/lottery',
} as const

/** Builder for the parametrized /game/:brandId route. */
export function gameRoute(brandId: string): string {
  return `/game/${encodeURIComponent(brandId)}`
}

/** Builder for the parametrized /dashboard-brand/:brandId route. */
export function dashboardBrandRoute(brandId: string): string {
  return `/dashboard-brand/${encodeURIComponent(brandId)}`
}
